import React, { Component } from 'react';
import { Container, Row, Col, Card, Badge, Alert } from 'react-bootstrap';
import Octicon, {Book, Database, History, Gear, Repo, Sync} from '@github/octicons-react';
import { GoBook, GoDatabase, GoSync } from 'react-icons/go';
import ExplorePane from 'blob_types/blobhub/graph/orientdb/explore/index';
import DetailsPane from 'blob_types/blobhub/graph/orientdb/details/index';
import Graph from 'blob_types/blobhub/graph/orientdb/explore/graph';
import "./index.css";

function graphPhaseLabel(revision) {
  if (!revision) return "Loading...";
  if (revision.phase === "draft") return "Draft";
  if (revision.phase === "commit") return "Commit";
  if (revision.phase === "snapshot") return "Snapshot";
  return "Loading...";
}

export default class BlobShell extends Component {
  static getTabs({ revision }) {
    return [
      {
        key: "default",
        title: graphPhaseLabel(revision),
        icon: GoDatabase,
        isDefault: true,
      },
      { key: "publish",       title: "Publish",       icon: GoBook },
      { key: "synchronizers", title: "Synchronizers", icon: GoSync, disabled: true },
    ];
  }

  constructor(props) {
    super(props);

    this.state = {
      details: {
        visible: false,
        view: "summary",
        data: null
      },
      graph: new Graph(),
      appearance: null,
      shellInterface: {
        setAppearance: this.setAppearance,
        updateDetails: this.updateDetails,
        toggleDetails: this.toggleDetails
      },
      queryInterface: null,
      previewInterface: null,
      graphCtrlInterface: null,
      appearanceInterface: null
    };
  }

  /**
   * Shell interface
   */

  setAppearance = (appearance) => {
    // Remember locally
    this.setState({
      appearance: appearance
    });

    // Update the graph
    this.state.previewInterface.refreshAppearance();
  }

  updateDetails = (visible, view, data) => {
    this.setState({
      details: {
        visible: visible,
        view: view,
        data: data
      }
    });
  }

  toggleDetails = () => {
    let details = this.state.details;
    details.visible = !details.visible;
    this.setState({
      details: details
    });
  }

  /**
   * UX
   */

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    this.state.previewInterface.activate();
  }

  render() {
    return (
      <>
        <div
          className={
            this.props.app.screenMode === "normal"
            ? "container blob-header-row content-row"
            : "blob-header-row content-row"
          }>
          <Row>
            <Col sm={this.state.details.visible ? 8 : 12}>
              <ExplorePane
                app={this.props.app}
                blob={this.props.blob}
                revision={this.props.revision}
                shell={this.state}
              />
            </Col>
            {this.state.details.visible &&
              <Col sm={4}>
                <DetailsPane
                  app={this.state}
                  blob={this.props.blob}
                  revision={this.props.revision}
                  shell={this.state}
                />
              </Col>
            }
          </Row>
        </div>
      </>
    )
  }
}
